import React from 'react';

const CheckMarkIcon = ({
  typeOfCheckmark = '',
  color,
  width = '24',
  height = '25',
}: {
  typeOfCheckmark?: string;
  color?: string;
  width?: string;
  height?: string;
}) => {
  return typeOfCheckmark === 'plans' ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_1741_91467)">
        <path
          opacity="0.5"
          d="M12 24.7813C18.6274 24.7813 24 19.4087 24 12.7813C24 6.15383 18.6274 0.78125 12 0.78125C5.37258 0.78125 0 6.15383 0 12.7813C0 19.4087 5.37258 24.7813 12 24.7813Z"
          fill={color || '#3E8E2A'}
        />
        <path
          d="M16.5711 9.63672L10.2854 15.9224L7.42822 13.0653"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1741_91467">
          <rect width={width} height={height} fill="white" transform="translate(0 0.78125)" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.89209C6.4774 2.89209 2 7.36929 2 12.8921C2 18.4149 6.4774 22.8921 12 22.8921C17.5232 22.8921 22 18.4149 22 12.8921C22 7.36929 17.523 2.89209 12 2.89209ZM10.1656 18.0289L5.7624 13.6259L7.23 12.1583L10.1656 15.0937L16.77 8.48909L18.2376 9.95669L10.1656 18.0289Z"
        fill={color || '#6AC259'}
      />
    </svg>
  );
};

export default CheckMarkIcon;
